import '../application';

$(document).ready(() => {
  // Search button click event.
  $('#search-submit').click(function () {
    const $input = $(this).prev('input[type=text]');
    $input.focus();
    return $input.val().length > 0;
  });
});
